export default __webpack_public_path__ + "static/media/p2023-21.51a3970a.jpeg";